<template>
  <div class="max-width-md u-mrg-center">
    <div>
      <div v-show="!isCreated" class="u-txt-center">
        <h2 class="h-lg u-mrg-btm-half" v-html="createAccountTitle"></h2>
        <div class="u-mrg-btm-half" v-html="createAccountSubhead"></div>
        <div v-html="createAccountContent"></div>
      </div>
      <div v-show="!isCreated" class="max-width-sm u-mrg-center u-mrg-top-half u-mrg-btm-2x">
        <div class="u-mrg-btm-half">
          <label v-bind:for="'firstname' + uniqueId" class="u-vis-hidden">
            <strong>First name</strong>
          </label>
          <input type="text" name="firstname" v-bind:id="'firstname' + uniqueId" class="input" placeholder="First Name*"
            v-model="createFirstname" />
          <div class="error u-padd-btm-none" v-show="submitted && createFirstname === ''">
            <strong>Please enter your name.</strong>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <label v-bind:for="'lastname' + uniqueId" class="u-vis-hidden">
            <strong>Last name</strong>
          </label>
          <input type="text" name="lastname" v-bind:id="'lastname' + uniqueId" class="input" placeholder="Last Name*"
            v-model="createLastname" />
          <div class="error u-padd-btm-none" v-show="submitted && createLastname === ''">
            <strong>Please enter your name.</strong>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <label v-bind:for="'emailAdress' + uniqueId" class="u-vis-hidden">
            <strong>Email address</strong>
          </label>
          <input type="email" name="emailAdress" v-bind:id="'emailAdress' + uniqueId" placeholder="Email Address*"
            v-model="createEmail" class="input" />
          <div class="error u-padd-btm-none" v-show="submitted && createEmail === ''">
            <strong>Please enter your email.</strong>
          </div>
          <div class="error u-padd-btm-none" v-show="submitted && invalidEmail">
            <strong>Please enter a valid email address.</strong>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <label v-bind:for="'phone' + uniqueId" class="u-vis-hidden">
            <strong>Phone</strong>
          </label>
          <input name="phone" :id="'phone' + uniqueId" placeholder="Phone*"
            v-model="createPhone" class="input" v-mask="'+1 (###) ###-####'" @input="changePhone" type="tel" />
          <div class="error u-padd-btm-none" v-show="submitted && createPhone === ''">
            <strong>Please enter your phone number.</strong>
          </div>
          <div class="error u-padd-btm-none" v-show="submitted && invalidPhone">
            <strong>Please enter a valid phone number.</strong>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <div class="form-element form-element__select">

            <label v-bind:for="'country' + uniqueId" class="visuallyhidden">Country</label>
            <select autocomplete="country" class="select country-select" @change="onChangeCountry($event);" name="country"
              v-bind:id="'country' + uniqueId" v-model="selectedCountry"
              :class="{ error: selectedCountry === '' && submitted }" required>
              <option value="">Country*</option>
              <option v-for="(item, index) in countries" :value="item" v-html="item" :key="`country_${index}`"></option>
            </select>

            <div class="chevron-down"></div>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <div class="form-element form-element__select" v-if="selectedCountry == 'United States'">

            <label v-bind:for="'state' + uniqueId" class="visuallyhidden">State/Province</label>
            <select autocomplete="address-level1" class="select state-select" @change="onChangeState($event);" name="state" v-model="selectedState"
              v-bind:id="'state' + uniqueId" :class="{ error: selectedState === '' && submitted }" required>
              <option value="">State*</option>
              <option :key="`state_${index}`" v-for="(item, index) in states" :value="item" v-html="item"></option>
            </select>

            <div class="chevron-down"></div>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <div class="form-element form-element__select " v-if="selectedCountry == 'Canada'">

            <label v-bind:for="'province' + uniqueId" class="visuallyhidden">Province</label>
            <select autocomplete="address-level1" name="province" class="select state-select" v-bind:id="'province' + uniqueId"
              v-model="selectedState" @change="onChangeProvince($event);"
              :class="{ error: selectedState === '' && submitted }" required>
              <option value="" disabled>Province*</option>
              <option :key="`prov_${index}`" v-for="(item, index) in provinces" :value="item" v-html="item"></option>
            </select>

            <div class="chevron-down"></div>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <div v-if="canSelectCounty" class="form-element form-element__select ">
            <label v-bind:for="'county' + uniqueId" class="visuallyhidden">County*</label>

            <select autocomplete="address-level2" class="select county-select" :class="{ error: selectedCounty === '' && submitted }"
              v-model="selectedCounty" @change="onChangeCounty($event);" name="county" v-bind:id="'county' + uniqueId"
              required>
              <option value="" disabled>County*</option>
              <option v-for="(item, index) in counties" :key="`county_${index}`" :value="item" v-html="item"></option>
            </select>

            <div class="chevron-down"></div>
          </div>
        </div>
        <div class=" u-mrg-btm-none" v-if="unSelectedValues">
          <span class="error">Please select a <span>Country</span>, State or Province and County
            or District.</span>
        </div>
        <div class="u-mrg-btm-half">
          <label v-bind:for="'company' + uniqueId" class="u-vis-hidden">
            <strong>Company</strong>
          </label>
          <input type="text" name="company" v-bind:id="'company' + uniqueId" class="input" placeholder="Company*"
            v-model="createCompany" />
          <div class="error u-padd-btm-none" v-show="submitted && createCompany === ''">
            <strong>Please enter company.</strong>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <div class="form-element form-element__select">
            <label class="u-vis-hidden" v-bind:for="'customerType' + uniqueId"> Customer Type* </label>
            <select class="select" v-bind:id="'customerType' + uniqueId" name="customerType" required
              v-model="customerType">
              <option id="customerType1x" disabled selected value=""> Customer Type* </option>
              <option v-for="(type, index) in customerTypes" :key="`type_${index}`" :value="type">
                {{ type }}
              </option>
            </select>
            <div class="chevron-down"></div>
          </div>
          <div class="error u-padd-btm-none" v-show="submitted && customerType === ''">
            <strong>Please select a customer type.</strong>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <label v-bind:for="'create-password' + uniqueId" class="u-vis-hidden">
            <strong>Password</strong>
          </label>
          <input type="password" name="create-password" v-bind:id="'create-password' + uniqueId" placeholder="Password*"
            v-model="createPassword" class="input" />
          <div class="error u-padd-btm-none" v-show="submitted && createPassword === ''">
            <strong>Please enter a password.</strong>
          </div>
          <div class="error u-padd-btm-none" v-show="submitted && invalidPassword && createPassword !== ''">
            <strong>Password is invalid. Passwords must be at least 8
              characters.</strong>
          </div>
        </div>

        <div class="u-mrg-btm-half">
          <label v-bind:for="'createPasswordConfirm' + uniqueId" class="u-vis-hidden">
            <strong>Confirm password*</strong>
          </label>
          <input type="password" name="createPasswordConfirm" v-bind:id="'createPasswordConfirm' + uniqueId"
            class="input" placeholder="Confirm Password*" v-model="createPasswordConfirm" />
          <div class="error u-padd-btm-none" v-show="submitted && createPassword === ''">
            <strong>Please enter a password.</strong>
          </div>
          <div class="error u-padd-btm-none" v-show="submitted && invalidPasswordConfirm && createPassword !== ''
            ">
            <strong>Confirm password is invalid. Passwords must be at least 8
              characters.</strong>
          </div>
        </div>

        <div v-show="passwordMismatch" class="error">
          <strong>Passwords do not match</strong>
        </div>
        <div v-show="error !== ''" class="error">
          <strong>{{ error }}</strong>
        </div>

        <div class="">
          <div class="u-inline-block u-txt-sm form-element form-element__checkbox">
            <input type="checkbox" name="create-accept-terms" v-bind:id="'create-accept-terms' + uniqueId"
              v-model="createAcceptTerms" />
            <label v-bind:for="'create-accept-terms' + uniqueId" class="u-mrg-btm-half u-mrg-top-half">
              I accept
              <a :href="termsLink" class="accept-terms">Terms and Conditions</a>
            </label>

            <div v-show="mustAccept" class="error u-mrg-top-half">
              <strong>You must accept the terms and conditions.</strong>
            </div>
          </div>


          <div class="u-inline-block u-txt-sm form-element form-element__checkbox">
            <input type="checkbox" name="optin-comm" v-bind:id="'optin-comm' + uniqueId" v-model="createOptInComm" />
            <label v-bind:for="'optin-comm' + uniqueId">
              Yes! Keep me up to date with the latest news and promotions
            </label>
          </div>

          <div ref="captcha" class="u-inline-block u-mrg-btm-half u-mrg-top-half"
            :data-sitekey="captchaKey"></div>
          <div class="captcha-msg-error"></div>          
          
          <button class="btn btn--blue btn--wide u-mrg-top-half u-display-block" :data-sitekey="captchaKey"
            data-action="submit" @click.prevent="createAccount" v-html="createAccountCta"></button>
        </div>
      </div>
      <div v-bind:id="'thankyou' + uniqueId" v-show="isCreated && !isModal" ref="thankyou"
        class="max-width-md u-mrg-center u-mrg-top u-txt-center">
        <h2 class="h-lg u-txt-center" v-html="thankYouTitle"></h2>
        <button @click.prevent="openLogin" class="btn btn--blue btn--wide u-mrg-btm-2x" v-html="thankYouCta"></button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import UserAPI from "../../utils/api/user";
import UserEvents from "@scripts/utils/events/user"
import { findUniqueValuesIn } from "../../utils/common";
import { isValidEmail } from "../../utils/forms/helpers";
import CSCLookup from "../../utils/csc-lookup";
import { waitForGlobal } from "../../utils/wait-for-global";
import { getRandomId } from "../../utils/random";

function isValidPhoneNumber(phoneNumber) {
    const regex = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;
    return regex.test(phoneNumber);
}

export default {
  components:{
  },
  props: {
    captchaKey: String,
    //CreateAccountModal props
    createAccountTitle: String,
    createAccountSubhead: String,
    createAccountContent: String,
    termsLink: String,
    createAccountCta: String,
    customerTypes: Array,
    //ThankYouModal props
    thankYouTitle: String,
    thankYouCta: String,
    dataUrl: String,
    accountLoginUrl: String,
    toolName: String,

    isModal: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      success: false,
      error: "",
      userData: {},
      catpchaId: "",
      // remember: false,
      createFirstname: "",
      createLastname: "",
      createPassword: "",
      createPasswordConfirm: "",
      createEmail: "",
      createPhone: "",
      createCompany: "",
      createCounty: "",
      createState: "",
      createCountry: "",
      customerType: "",
      api: null,
      captchaResponse: null,
      submitted: false,
      invalidEmail: false,
      invalidPhone: false,
      createPasswordInvalid: false,
      createPasswordConfirmInvalid: false,
      passwordMismatch: false,
      invalidPassword: false,
      invalidPasswordConfirm: false,
      createAcceptTerms: false,
      createOptInComm: false,
      mustAccept: false,
      selectedCountry: "",
      selectedState: "",
      selectedCounty: "",
      isCreated: false,
      countries: [],
      states: [],
      counties: [],
      provinces: [],
      unSelectedValues: false,
      responseLocations: [],
      lookups: {},
      uniqueId:"ukn",
      captchaId:"",
    };
  },

  methods: {
    acceptState: function(e){
      console.log("accept state", e.target.value);
    },  
    changePhone:function(e){
      //handle native browser autofil
      this.createPhone = e.target.value;
    },
    createAccount() {
      this.submitted = true;
      if (this.isValid()) {
        this.captchaResponse = grecaptcha.getResponse(this.catpchaId);
        if (this.captchaResponse.length === 0) {
          // TODO: non-scoped message
          $(".captcha-msg-error").text(
            "Please validate that you are not a robot"
          );
        } else {
          $(".captcha-msg-error").text("");
          this.api.create(this.formData);
        }
      } else {
        console.log(this.isValid(), "A field failed to validate");
      }
    },
    isValid() {
      let valid = true;
      console.log(this.customerType);
      if (
        this.createFirstname === "" ||
        this.createLastname === "" ||
        this.createCompany === "" ||
        this.createState === "" ||
        this.createCountry === "" ||
        this.createEmail === "" ||
        this.createPhone === "" ||
        this.createPassword === "" ||
        this.createPasswordConfirm === "" ||
        this.customerType === ""
      ) {
        valid = false;

        // console.log('first name, last name, password, state or county failed');
      }
      if (valid && !isValidEmail(this.createEmail)) {
        this.invalidEmail = true;
        console.log("email fields failed");

        valid = false;
      }

      //todo: invalid phone?
      if(!isValidPhoneNumber(this.createPhone)){
        valid=false;
        this.invalidPhone=true;
      } else{
        this.invalidPhone=false;
      }

      if (valid) {
        if (this.createCountry === 'United States' && this.createCounty === "") {
          valid = false

        } // allow canada to pass through
      }

      if (valid) {
        if (this.createPasswordConfirm !== this.createPassword) {
          this.passwordMismatch = true;
          valid = false;
          console.log("password fields failed");
        }
        if (!this.passwordValid(this.createPassword)) {
          this.invalidPassword = true;
          console.log("password fields failed/invalid");
          valid = false;
        }
        if (!this.passwordValid(this.createPasswordConfirm)) {
          this.invalidPasswordConfirm = true;
          console.log("confirm password fields failed/invalid");
          valid = false;
        }
      }



      if (valid && !this.createAcceptTerms) {
        valid = false;
        this.mustAccept = true;
      } else {
        this.mustAccept = false;
      }

      return valid;
    },
    passwordValid(pass) {
      return pass.length >= 8;
    },
    openLogin() {
      if (this.isModal) {
        this.$emit("userAction", "login");
      } else {
        window.location = this.accountLoginUrl;
      }
    },
    onFailedCreatedAccount(event){
      grecaptcha?.reset(this.catpchaId);
      this.error = event.detail.responseText;
    },
    onCreatedAccount() {
      let modal = false;
      if (!!this.isModal) {
        modal = true;
        this.$emit("userAction", "accountCreated");
      } else {
        //Desktop version - show Thank You and scroll to top
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }

      //@ga create account tracking: https://projects.ingentek.com/app/tasks/42136463
      const eventName = `create-account${this.createOptInComm?'-optin':''}|${modal?`${window.toolName}_tool`:`account_page`}`;
      window.dataLayer.push({
        event: eventName
      });

      // isCreated will hide the form and display Thank You message from props
      this.isCreated = true;
    },
    setCreateVals() {
      this.createCounty = this.selectedCounty;
      this.createCountry = this.selectedCountry;
      this.createState = this.selectedState;
    },
    onChangeCountry(event) {
      this.initialized = true;
      this.selectedCountry = event.target.value;
      this.selectedState = "";

      this.selectedCounty = "";

      window.dataLayer.push({
        event: "filter",
        filter_type: "Country",
        selection: this.selectedCountry,
      });
      if (this.selectedCountry === 'United States') {
        this.states = this.lookups.getTerritoriesByCountry(this.selectedCountry);
      } else {
        this.provinces = this.lookups.getTerritoriesByCountry(this.selectedCountry);
      }
      this.setCreateVals();
    },
    onChangeState(event) {
      this.selectedState = event.target.value;
      this.selectedCounty = "";
      
      window.dataLayer.push({
        event: "filter",
        filter_type: "State",
        selection: this.selectedState,
      });
      this.counties = this.lookups.getCountiesByTerritory(
        this.selectedCountry,
        this.selectedState
      );
      this.setCreateVals();
    },
    onChangeProvince(event) {
      this.selectedState = event.target.value;
      this.selectedCounty = "";
      window.dataLayer.push({
        event: "filter",
        filter_type: "Province",
        selection: this.selectedState,
      });
      this.counties = this.lookups.getCountiesByTerritory(
        this.selectedCountry,
        this.selectedState
      );
      this.setCreateVals();
    },
    onChangeCounty(event) {
      this.selectedCounty = event.target.value;
      window.dataLayer.push({
        event: "filter",
        filter_type: "County",
        selection: this.selectedCounty,
      });
      this.setCreateVals();
    },
  },
  watch: {
    createFirstName(newVal, oldVal) { },
  },
  computed: {
    formData() {
      return {
        firstName: this.createFirstname,
        lastName: this.createLastname,
        email: this.createEmail,
        phone: this.createPhone,
        company: this.createCompany,
        password: this.createPassword,
        captcha: this.captchaResponse,
        accept: this.createAcceptTerms,
        // remember: this.remember,
        state: this.createState,
        country: this.createCountry,
        county: this.createCounty,
        signup_reason: this.toolName,
        optin_comm: this.createOptInComm,
        customer_type: this.customerType
      };
    },

    canSelectCounty() {
      if (this.selectedCountry === "Canada") {
        return false;
      } else {
        if (this.selectedState !== "") {
          return true;
        }
      }
    },
  },
  mounted() {
    window.dataLayer = window.dataLayer || [];
    this.api = new UserAPI(window.APIDEF);
    const userEvents = new UserEvents();

    this.countries = new Set();
    this.states = new Set();
    this.counties = new Set();
    this.provinces = new Set();

    //instantiate recaptcha
    waitForGlobal("window.grecaptcha.render", () => {
        this.catpchaId = grecaptcha.render(this.$refs.captcha);
        console.log('CRA: captcha element mounted');
    });
    
    //register events
    window.addEventListener(userEvents.eventCreatedAccount, this.onCreatedAccount);
    window.addEventListener(userEvents.eventCreateFailed, this.onFailedCreatedAccount);

    // console.log(this.toolName, 'tool name');

    this.$nextTick(() => {
      axios.get(`${this.$props.dataUrl}`).then((response) => {
        this.responseData = response.data;
        let tmpCountries = [];
        let tmpLocations = [];
        this.responseData.forEach((element, index) => {
          tmpLocations.push(element);
          element.Locations.forEach((location, index) => {
            tmpCountries.push(location);
          });
        });

        this.lookups = new CSCLookup(tmpLocations);

        this.countries = findUniqueValuesIn(tmpCountries, "Country");
        this.countries = this.countries.sort((a, b) => {
          let nameA = a.toUpperCase(); // ignore upper and lowercase
          let nameB = b.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        });
        // this.states = findUniqueValuesIn(tmpCountries, 'Country')
        //console.log(this.countries);
        // this.countries = findUniqueValuesIn(element.Locations)
      });
    });
    // see above event listener that is triggered to see how this component receives its data models
  },
  beforeUnmount() {
    const userEvents = new UserEvents();
    window.removeEventListener(userEvents.eventCreatedAccount, this.onCreatedAccount);
    window.removeEventListener(userEvents.eventCreateFailed, this.onFailedCreatedAccount);
  },
  created(){
    this.uniqueId = getRandomId();
  }
};

</script>
